import curry from 'lodash/curry';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import IThemeInterface from '../../Theme/common';

import { normalizeColor } from './normalizeColor';

export interface IBoxShadowStyleData {
  color?: string;
  inset?: boolean;
  shadow?: string;
}

export type VALID_SHADOW_DATA = IBoxShadowStyleData[] | IBoxShadowStyleData | string;

export const calcBoxShadowStyles = curry((
  theme: IThemeInterface,
  data: VALID_SHADOW_DATA,
): FlattenSimpleInterpolation => {
  if (!!theme.global.elevation[data as string]) {
    return calcBoxShadowStyles(theme, theme.global.elevation[data as string]);
  }

  if (typeof data === 'string') {
    return css`
      box-shadow: ${data};
    `;
  } else {
    // allows multiple shadows
    const shadowData = Array.isArray(data) ? data : [data];

    const shadowStr = shadowData.map(shadowObj => {
      const color = shadowObj.color ? normalizeColor(theme, shadowObj.color) : normalizeColor(theme, 'black');
      const direction = shadowObj.inset ? 'inset' : '';
      const shadow = shadowObj.shadow ? shadowObj.shadow : '0 0 0 0';

      return `${direction} ${shadow} ${color}`;
    })
    .toString();

    return css`
      box-shadow: ${shadowStr};
    `;
  }
});
